import { render } from "./yearlyOverview.vue?vue&type=template&id=636ffd3f"
import script from "./yearlyOverview.vue?vue&type=script&lang=js"
export * from "./yearlyOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__